import { Provider } from "@angular/core";
import type { ProvideWkDataTableOptions } from "./data-table.types";
import { WK_DATATABLE_ID } from "./data-table.tokens";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";
import { WkDataTablePersistenceService, WkDataTableRegistryService, WkDataTableStoreService } from "./store";
import { WkDataTableSortService, WkDataTableSearchService } from "./data-table.components";

export function provideWkDataTable(options: ProvideWkDataTableOptions, providers: Provider[] = []): Provider[] {
    return [
        ...providers,
        WkDataTableSearchService,
        WkDataTableSortService,
        WkDataTableContextService,
        WkDataTablePersistenceService,
        WkDataTableRegistryService,
        WkDataTableStoreService,
        options.resolver,

        ...options.columnsProvider,
        ...options.rowProvider,

        {
            provide: WK_DATATABLE_ID,
            useValue: options.id,
        },
    ];
}
